<template>
  <div id="orderInfo">
  	<mt-header title="订单详情"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
		  <a href="/" slot="right">
		    <mt-button><img src="../../../static/images/go_home_ico.png" width="23"/></mt-button>
		  </a>
 	</mt-header>
 	<div class="mt40"> 
 	   <section class="orderType">
 	   	 <p class="colorff8900 font-size10">{{state==1?'待付款':state==2?'交易中':state==3?'待发货':state==4?'待收货':state==5?'交易成功':'交易关闭'}}</p>
 	   	 <P class="color666 font-size8" v-show="state==1">剩余付款时间: {{remainTime}}</P>
 	   	 <P class="color666 font-size8" v-show="state==2">付款成功，正在为您出服务，请稍等</P>
 	   	 <P class="color666 font-size8" v-show="state==5">请确认查收您的到账信息</P>
 	   	 <P class="color666 font-size8" v-show="state==6">您的订单已关闭</P>
 	   </section>
 	   <p class="colorBox"></p>
 	   <section>
 	   	<div class="reset-mintbox">
			 	<label class="labelr">商品</label>
			 	<!--<input type="text" disabled  v-model="goods"/>-->
			 	<label class="labelp">{{goods}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">类型</label>
			 	<!--<input type="text" disabled  v-model="typeText"/>-->
			 	<label class="labelp">{{typeText}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">面值</label>
			 	<!--<input type="text" disabled  v-model="facevalue" class="colorff5513"/>-->
			 	<label class="labelp colorff5513">{{type==1?facevalue:Qnum==1?facevalue: Qnum+'Q币'}}</label>
		  </div>
		  <div class="reset-mintbox" v-show="type==2&&chargeaccount!=''">
			 	<label class="labelr">充值账号</label>
			 	<!--<input type="text" disabled  v-model="chargeaccount"/>-->
			 	<label class="labelp">{{chargeaccount}}</label>
		  </div>
 	   	<!--网易一卡通  购买用途-->
 	   	<div class="reset-mintbox" v-show="type==2&&purpose!=''">
			 	<label class="labelr">购买用途</label>
			 	<!--<input type="text" disabled  v-model="purpose2"/>-->
			 	<label class="labelp">{{purpose2}}</label>
		  </div>
 	   </section>
 	   <p class="colorBox"></p>
 	   <section class="orderinfors">
 	   	<div class="reset-mintbox">
			 	<label class="labelr">商品总额</label>
			 	<!--<input type="text" disabled  v-model="ordertime"/>-->
			 	<label class="labelp">{{allPrice}}{{paytype==1?'元':paytype==2?'元':paytype==3?'元':paytype==4?'V':paytype==5?'元':'V'}}</label>
		  </div>
		  <div class="reset-mintbox" v-show="coupon.length!=0">
			 	<label class="labelr">优惠券</label>
			 	<!--<input type="text" disabled  v-model="ordertime"/>-->
			 	<label class="labelp">{{"-"+couponPrice+"元"}}</label>
		  </div>
 	   	<div class="reset-mintbox">
			 	<label class="labelr">订单金额</label>
			 	<!--<input type="text" disabled  v-model="price" class="colorff5513"/>-->
			 	<label class="labelp colorff5513">{{price}}{{paytype==1?'元':paytype==2?'元':paytype==3?'元':paytype==4?'V':paytype==5?'元':'V'}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">订单编号</label>
			 	<!--<input type="text" disabled  v-model="ordernum"/>-->
			 	<label class="labelp">{{ordernum}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">下单时间</label>
			 	<!--<input type="text" disabled  v-model="ordertime"/>-->
			 	<label class="labelp">{{ordertime}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">支付方式</label>
			 	<!--<input type="text" disabled  v-model="paytypeText"/>-->
			 	<label class="labelp">{{paytype==1?'微信支付':paytype==2?'支付宝支付':paytype==3?'QQ钱包支付':paytype==4?'V币支付':paytype==5?'话费支付':'电话钱包支付'}}</label>
		  </div>
		  <div class="reset-mintbox" v-show="state==5||state==2">
			 	<label class="labelr">支付完成时间</label>
			 	<!--<input type="text" disabled   v-model="finishtime"/>-->
			 	<label class="labelp">{{finishtime}}</label>
		  </div>
 	   </section>
 	   <p class="colorBox"></p>
 	   <!--卡密信息-->
 	   <section class="secretinfobox" v-show="type==1&&cards.length!=0">
 	   	 <div class="secretinfo_title">
   	 		<span class="float-left color666 font-size10">卡密信息</span>
   	 		<a href="javascript:void(0)" class="float-right colorff8900 font-size8" @click="cipboardCopy">复制到粘贴板</a>
 	   	 </div>
 	   	 <div class="border-bottom-lined6" v-for="item in cards">
 	   	 	<div class="reset-mintbox">
				 	<label class="labelr">卡号</label>
				 	<!--<input type="text" disabled  :value="item.cardNum"/>-->
				 	<label class="labelp">{{item.cardNum}}</label>
		    </div>
		    <div class="reset-mintbox">
				 	<label class="labelr">密码</label>
				 	<!--<input type="text" disabled  :value="item.cardPwd"/>-->
				 	<label class="labelp">{{item.cardPwd}}</label>
		    </div>
		    <div class="reset-mintbox">
				 	<label class="labelr">有效期</label>
				 	<!--<input type="text" disabled  :value="item.validDate"/>-->
				 	<label class="labelp">{{item.validDate}}</label>
		    </div>
 	   	 </div>
 	   	 <textarea id="areaText" readonly="readonly"></textarea>
 	   </section>
 	   <section>
 	   	<p class="precent92 clearfix">
 	   	 <!--待付款-->
 	   	    <span v-show="state==1">
 	   	     <a href="javascript:void(0)" class="btnpay btncancel w50  float-left" @click="btnCancel">取消订单</a>
 	   		   <a href="javascript:void(0)" class="btnpay w50 float-right"  @click="impay">立即付款</a>
 	   		  </span>
 	   	 <!--交易中  交易关闭-->
 	   	    <a href="tel:0755-82126233" class="btnpay" v-show="state==2||state==6">联系客服</a>
 	   	 <!--交易成功-->
 	   	    <span v-show="state==5">
 	   	    	<input type="button" value="再次下单" class="btnpay w50 float-left"  @click="reorder"/>
 	   	    	 <a href="tel:0755-82126233" class="btnpay w50 float-right">联系客服</a>
 	   	    </span>
 	   	</p>
 	   </section>
 	</div>
  </div>
</template>
 
<script>
 import { MessageBox } from 'mint-ui';
 import { Toast } from 'mint-ui'
 import { Indicator } from 'mint-ui'
 export default{
  	data(){
		return{
			orderId:localStorage.getItem("orderId"),
			state:"",
			goods:"",
			type:"",
			typeText:"",
			facevalue:"",
			facevalue2:"",
			chargeaccount:"",
			purpose:"",//网易一卡通
			purpose2:"",
			price:"",
			ordernum:"",
			ordertime:"",
			paytype:"",
			paytypeText:"",
			coupon:"",//优惠券信息
			couponPrice:"",//优惠券金额
			allPrice:"",//商品总额
			finishtime:"",//支付完成时间
			remainTime:"",
			cards:[],
			urlPrefix:this.URL_PREFIX,
			spsuc:this.URL_PAY,//支付成功后返回页面
			Qnum:1,
			md5sign:this.Act_md5sign,
		}
	},
	created:function(){
	  	this.queryInfo();
	},
//	watch: {
//			Qnum:function(newV,oldV){
//				if(newV==1){
//					this.facevalue2 ="100Q币";
//				}else{
//					this.facevalue2 =Qnum + "Q币";
//				}
//			}
//	},
	methods: {
		returnBack(){
	    this.$router.push({path: "/Order/orderList",query:{state:localStorage.getItem("listState")}});
	  },
	  //待付款状态中的立即付款
	  impay(){
	  	this.$http.post(this.URL_PREFIX+"/order/createOrder.net",{orderId:this.orderId,spsuc:this.spsuc})
	    .then((res) =>{
	  	  if(res.data.code!=200){
	  	  	  Toast(res.data.msg);
	  	  }else{
	  	  	  var orderId=res.data.remarks;
	  	  	  localStorage.setItem("orderId",orderId);
	  	  	  location.href=res.data.obj;
	  	  }
	   });
	  },
	  //获取订单信息
	  queryInfo(){
	  	this.$http.post(this.URL_PREFIX+"/order/findOrderByOid.net",{orderId:this.orderId})
	  	  .then((res) =>{
//	  	  	 console.log('卡密订单状态');
//	  	  	 console.log(res);
	  	  	 this.state=res.data.obj.state;
	  	  	 this.goods=res.data.obj.tranEvent;
	  	  	 this.type=res.data.obj.tranType;
	  	  	 if(this.type==1){
	  	  	 	 this.typeText='卡密';
	  	  	 }else{
	  	  	 	 this.typeText='直充';
	  	  	 	 this.Qnum=res.data.obj.num;
	  	  	 }
	  	  	 this.facevalue=res.data.obj.pName;
	  	  	 this.chargeaccount=res.data.obj.rechPhone;
	  	  	 this.purpose=res.data.obj.purpose;
	  	  	 if(this.purpose==0){
	  	  	 	  this.purpose2='账号直充';
	  	  	 }else if(this.purpose==1){
	  	  	 	  this.purpose2='点数寄存';
	  	  	 }
	  	  	 this.ordernum=res.data.obj.orderId;
	  	  	 this.ordertime=res.data.obj.cTime;
	  	  	 this.paytype=res.data.obj.payType;
	  	  	 this.finishtime=res.data.obj.fTime;
	  	  	 this.cards=res.data.obj.cards;
	  	  	 this.price=res.data.obj.amount;//订单金额
	  	  	 this.coupon=res.data.obj.coupon;//优惠信息
	  	  	 if(this.coupon.length==0){
	  	  	   	this.allPrice= this.price;//商品总额
	  	  	 }else{
	  	  	   	this.allPrice= this.coupon.ydetails;//商品总额
	  	  	 	  this.couponPrice=res.data.obj.coupon.yamount;//优惠金额
	  	  	 }
	  	  	 if(this.state==1){
	  	  	 	 this.countDown();
	  	  	 }
	  	  });
	  },
	  //再次下单
	  reorder(){
	  	Indicator.open();
	    this.$http.post(this.URL_PREFIX+"/order/findOrderByProduct.net",{orderId:this.orderId})
	    .then((res) =>{
	    	if(res.data.obj!=null){
		    	var pid=res.data.obj.proId;
		    	var num=res.data.obj.num;
		  	  localStorage.setItem("price",res.data.obj.amount);
		     	localStorage.setItem("proName",res.data.obj.pName);
		     	localStorage.setItem("ttype",res.data.obj.tranType);
		     	localStorage.setItem("type",res.data.obj.tranType);
		     	localStorage.setItem("pic",res.data.obj.cateIcon);
		     	localStorage.setItem("tName",res.data.obj.tranEvent);
		     	localStorage.setItem("pid",pid);
		     	var obj=JSON.stringify(res.data.obj.pays);
		     	localStorage.setItem("payType",obj);
		     	localStorage.setItem("num",num);//数量
		     	localStorage.setItem("totalPrice",res.data.obj.amount);//总金额
		     	localStorage.setItem("citycode",res.data.obj.areaCode);//常登陆地
		     	localStorage.setItem("purpose",res.data.obj.purpose);//购买用途
		     	localStorage.setItem("account",res.data.obj.rechPhone);
		     	localStorage.setItem("freightR",res.data.obj.freight.R);  //保存人民币的运费
		     	localStorage.setItem("freightV",res.data.obj.freight.V);  //保存V币的运费
		     	this.validateStock(pid,num);
	     	}else{
  	    		Indicator.close();
  	    		Toast(res.data.msg);
  	    	}	
	    });
	  },
	  //库存风控验证
	  validateStock(pid,num){
//	  	Indicator.open();
	 	  this.$http.post(this.URL_PREFIX+"/order/exisStock.net",{proId:pid,num:num})
	  	.then((res) =>{
	  	  	 Indicator.close();
	  	  	 if(res.data.code==200){
	  	  	 	this.$router.push({path: '/Order/index'});
	  	  	 }else{
	  	  	 	Toast(res.data.msg);
	  	  	 }
	    });
	 },
	 //剩余付款时间计时函数
	  countDown(){
	  	var countDownTimer;  	
	  	var nowDate = new Date();//当前时间
		  var orderTime= this.ordertime;//下单开始时间  
		  orderTime=orderTime.replace(new RegExp(/-/gm) ,"/"); 
		  var addTime=new Date(orderTime);
			var auto_order_cancel=2;
			var auto_totals=parseInt(auto_order_cancel*60*60);
			var ad_totals= parseInt((addTime.getTime()/1000)+auto_totals);  ///下单总秒数
      var totals= parseInt(ad_totals-(nowDate.getTime()/ 1000));///支付时长
      if(totals>0){
        var hour   = parseInt((totals / 3600) % 24);
        var minute = parseInt((totals / 60) % 60);
        var second = parseInt(totals % 60);
        this.remainTime=hour+'时'+minute+'分'+second+'秒';
        setTimeout(() => {        	
        this.countDown(); 
        }, 1000);
	    }else{
	    	clearTimeout(countDownTimer);
	      this.$http.post(this.URL_PREFIX+"/order/payError.net",{orderId:this.orderId})
	  	  .then((res) =>{
	  	  	 if(res.data.code==200){
	  	  	   this.state=6;
	  	  	 }else{
	  	  	 }
	  	  });
	    }        
	  },
	  cipboardCopy(){
	  	var secretInfo=this.cards;
	  	var info="";
	  	secretInfo.forEach(function(i){
	  		 info+="卡号:"+i.cardNum+"  "+"密码："+i.cardPwd+"\n";
	  	});
	  	var areaText = document.getElementById('areaText');
	  	areaText.value=info;
	    var currentFocus = document.activeElement;
	    areaText.focus();
	    areaText.setSelectionRange(0, areaText.value.length);
	    //console.log(document.execCommand('copy', false));
	    try{
			    if(document.execCommand('copy', false)){
			        Toast("已复制");
			    } else{
			        Toast("浏览器不支持该操作，请手动复制");
			    }
			} catch(err){
			        Toast("浏览器不支持该操作，请手动复制");
			}      
	    currentFocus.focus();
	  },
	  //取消订单
	  btnCancel(){
	  	MessageBox.confirm('',{message:'您确认取消该订单吗?', title:'提示'}).then(action => {
        var sign=md5('orderId='+this.orderId+'&'+this.md5sign);
        this.$http.post(this.URL_PREFIX+"/activity/clearOrderById",{orderId:this.orderId,sign:sign})
	  	  .then((res) =>{
	  	  	   if(res.data.code!=200){
	  	  	   	  Toast(res.data.msg);
	  	  	   }else{
	  	  	   	  this.state=6;
	  	  	   	  Toast("已取消");
	  	  	   }
	  	  });
	       
	     },
	     action=>{
	
	     },
		  );
	  }
	}
  }
</script>

<style scoped="scoped">
#areaText{position: absolute;top: 0;z-index:-1;border: none;opacity: 0;}
.orderType{padding:10px;background: #fff;}
.orderType p{line-height: 25px;}
.orderinfors{padding: 5px 0 8px 0;background: #fff;}
.precent92{width: 92%;margin: 10px auto;}
.btnpay.w50{width: 48%;}
.secretinfobox{background: #fff;overflow: hidden;position: relative;}
.secretinfo_title{padding: 12px;overflow: hidden;border-bottom:1px solid #D6D6D6;}
.border-bottom-lined6{border-bottom:1px solid #D6D6D6;padding: 5px 0 8px 0;}
.btnpay{width: 100%;height: 40px;background: #ff8920;color: #fff;font-size: 1.0rem;border-radius: 5px;-webkit-border-radius: 5px;margin-top:15px;border: none;line-height: 40px;display: inline-block;text-align: center;}
.btncancel{background: #fff;color: #666;border: 1px solid #ddd;height: 39px;}
.reset-mintbox{height: 48px;line-height: 48px;padding: 0 15px 0 15px;background: #fff;border-bottom: 1px solid #eee;}
.reset-mintbox .labelr{float: left;color: #666;font-size: 0.8rem;}
/*.reset-mintbox input{text-align: right;float: right;color: #333;font-size: 0.9rem;border: none;margin-top: 14px;}*/
.reset-mintbox .labelp{text-align: right;float: right;color: #333;font-size: 0.9rem;border: none;}
.reset-mintbox .colorff5513{color:#ff5513;}
.orderinfors div.reset-mintbox,.secretinfobox div.reset-mintbox{border-bottom: none;height: 30px;line-height: 30px;}
.orderinfors div.reset-mintbox input,.secretinfobox div.reset-mintbox input{margin-top: 3px;}
</style>


// WEBPACK FOOTER //
// src/views/Order/orderInfo.vue